// extracted by mini-css-extract-plugin
export default {"header":"style_header__or-N-"};